import { render, staticRenderFns } from "./SifcopFilter.vue?vue&type=template&id=7919b49a&scoped=true"
import script from "./SifcopFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SifcopFilter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SifcopFilter.vue?vue&type=style&index=0&id=7919b49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7919b49a",
  null
  
)

export default component.exports